import {BASE_IMG_UPLOAD2} from "@/constant/_Public/Path";
import {getCookie} from "@/utils/auth";

export const sceneList = [{
  label: "作品集", url: BASE_IMG_UPLOAD2 + "pay/edu/scene1.png"
}, {
  label: "文化交流展示", url: BASE_IMG_UPLOAD2 + "pay/edu/scene2.png"
}, {
  label: "校园活动策划", url: BASE_IMG_UPLOAD2 + "pay/edu/scene3.png"
}, {
  label: "", url: BASE_IMG_UPLOAD2 + "pay/edu/scene4.png"
}]



